import React from 'react';
import { useState, useEffect } from 'react';
import './DesktopApp.scss';
import ImgLormnHeader from './img/lMN-logo-white.png';
import HeroImage from './img/Group_480982468.png';
import FooterImage from './img/LMN-logo-Footer1.png';

export default function DesktopApp() {
    const solutions = [
        'Robust audience targeting',
        'Premium native display',
        'Sponsored product ads',
        'Audience extension with programmatic activation',
        'Social media partnerships',
        'Closed-loop measurement and insights'
    ];

    const stats = [
        { value: '$83B', label: 'in sales in 2025' },
        { value: '1,750+', label: 'home improvement stores across U.S.' },
        { value: '39M+', label: 'average weekly visits on Lowe\'s digital platforms' },
        { value: '65% / 35%', label: 'DIY and PRO shopper split' }
    ];
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVariant(true);
        }, 300);
        return () => clearTimeout(timer);
    }, []);

    const scrollToSection = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="desktop">
            {/* Fixed Header */}
            <header className="header">
                <div className="header__container">
                <div className="header__logo">
                    <img src={ImgLormnHeader} alt="Lowe's Media Network" />
                </div>
                <nav className="header__nav">
                    <a onClick={() => scrollToSection('about')} className="header__nav-link">About us</a>
                    <a onClick={() => scrollToSection('solutions')} className="header__nav-link">Solutions</a>
                    <a href="mailto:lowesmedianetwork@lowes.com" className="header__contact-btn">Contact Us</a>
                </nav>
                </div>

            {/* Hero Section */}
            <section className={`hero ${isVariant ? 'variant' : ''}`}>
                <div className="hero__content">
                    <div className="hero__text">
                        <h1 className="hero__title">Your Home to Growth.</h1>
                        <p className="hero__subtitle">
                            Deliver meaningful impact beyond the last click.
                        </p>
                    </div>
                </div>

                <div className="hero__image-container">
                    <img
                        src={HeroImage}
                        alt="Lowe's associate helping customer"
                        className="hero__image"
                    />
                </div>
            </section>
            </header>



            {/* About Section */}
            <section className="about" id="about">
                <h2 className="about__title">Real-time data. Omnichannel reach. Proven results.</h2>
                <p className="about__description">
                    One of the fastest-growing retail media networks, Lowe&apos;s Media Network combines proprietary customer insights with
                    customizable omnichannel advertising solutions. We enable brands to connect with shoppers at every stage of the home
                    improvement journey; driving awareness, consideration and measurable performance.
                </p>
            </section>

            {/* Audience Section */}
            <section className="audience">
                <div className="audience__content">
                    <div className="audience__content-wrapper">
                        <h2 className="audience__title">
                            Get unparalleled access to 120M+ unique customers
                        </h2>
                        <p className="audience__text">
                            Both DIY and Pro customers turn to Lowe&apos;s for more than just shopping.
                            <br />
                            They come for inspiration, for the right services and for experiences that ultimately move
                            <br />
                            products from aisles to carts. With US shoppers spending more time at home, they are
                            <br />
                            making sure homes not only provide shelter, but also enhance their lives.
                            <br /><br />
                            Lowe&apos;s Media Network leverages rich first and third–party data to help brands meet a
                            <br />
                            wide range of marketing objectives with over 120M Lowe&apos;s customers, from share–of–shelf
                            <br />
                            and new product launches to seasonal promotions.
                        </p>
                    </div>
                </div>
                <div className="audience__stat-wrapper">
                    <div className="audience__stat">
                        <span className="audience__stat-value">39M+</span>
                        <span className="audience__stat-label">average weekly visits on<br />Lowe&apos;s digital platforms</span>
                    </div>
                </div>
            </section>

            {/* Solutions Section */}
            <section className="solutions" id="solutions">
                <div className="solutions__content">
                    <h2 className="solutions__title">
                        Solutions tailored to<br />
                        your business ambitions.
                    </h2>
                    <p className="solutions__description">
                        Lowe&apos;s Media Network offers brands a consultative approach and a robust
                        omnichannel suite of products and solutions. With an evolving product
                        repository, rich campaign performance insights, and flexible creative strategies,
                        there is a portfolio of solutions for every brand&apos;s goals.
                    </p>
                </div>
                <div className="solutions__list">
                    {solutions.map((solution, index) => (
                        <div key={index} className="solutions__item">
                            {solution}
                        </div>
                    ))}
                </div>
            </section>

            {/* Company Info and Stats */}
            <div className="company-stats">
                <div className="company-stats-wrapper">
                    {/* Company Info Section */}
                    <section className="company-info">
                        <p className="company-info__text">
                            Lowe&apos;s is a best-in-class home improvement retailer. We solve problems and fulfill dreams for the home. Lowe&apos;s Media Network supports brand partners in reaching our customers throughout their shopping journey, in store and online.
                        </p>
                    </section>

                    {/* Stats Section */}
                    <section className="stats">
                        <div className="stats__wrapper">
                            {stats.map((stat, index) => (
                                <div key={index} className="stats__item">
                                    <span className="stats__value">{stat.value}</span>
                                    <span className="stats__label">{stat.label}</span>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            </div>

            {/* CTA Section */}
            <section className="cta">
                <h2 className="cta__title">Welcome to Lowe&apos;s Media Network</h2>
                <p className="cta__subtitle">Get in touch to see how, together, we can move the needle for your brand.</p>
                <a href="mailto:lowesmedianetwork@lowes.com" className="cta__email">lowesmedianetwork@lowes.com</a>
            </section>

            {/* Footer */}
            <footer className="footer">
                <div className="footer__main-wrapper">
                    <div className="footer__brand">
                        <img src={FooterImage} alt="Lowe's Media Network" className="footer__logo" />
                        <span className="footer__tagline">We Help. Brands Grow.</span>
                    </div>

                    <div className="footer__content-wrapper">
                        <div className="footer__links">
                            <div className="footer__column">
                                <h4 className="footer__column-title">Privacy & Use</h4>
                                <a href="https://www.lowes.com/l/terms-and-conditions-of-use.html" className="footer__link">Terms</a>
                                <a href="https://www.lowes.com/l/privacy-and-security-statement.html" className="footer__link">Privacy Statement</a>
                                <a href="https://www.lowes.com/l/privacy-and-security-statement.html#interestadvertising" className="footer__link">Interest-Based Ads</a>
                            </div>

                            <div className="footer__column">
                                <a href="https://www.lowes.com/l/privacy-and-security-statement.html#addnoticecaliforniacustomer" className="footer__link">CA Privacy Rights</a>
                                <a href="https://www.lowes.com/l/privacy-and-security-statement.html#MoreAboutSale" className="footer__link">Do Not Sell My</a>
                                <a href="https://www.lowes.com/l/privacy-and-security-statement.html#MoreAboutSale" className="footer__link">Personal Information</a>
                            </div>

                            <div className="footer__column">
                                <a href="https://www.lowes.com/" className="footer__link footer__link--bold">Lowes.com</a>
                                <a href="https://corporate.lowes.com/investors" className="footer__link footer__link--bold">Investor Site</a>
                            </div>
                        </div>

                    </div>

                        <div className="footer__contact-wrapper">
                            <div className="footer__contact">
                                <span className="footer__contact-text">Got questions?</span>
                                <a href="mailto:lowesmedianetwork@lowes.com" className="footer__contact-btn">Contact Us</a>
                            </div>
                        </div>
                </div>
            </footer>
        </div>
    );
}
